import React, { Component } from 'react';
import ListLoader from '../../../../shared/util/list-loader';
import { titleCase } from '../../../../shared/util/string';
import { getTranslatedPhrase } from '../../../../shared/util/lang';
import CreateCouponModal from '../../../../shared/components/Modals/Account/CreateCouponModal';
import { currencyList } from '../../../../shared/util/string';
import moment from 'moment';
// const MORE_SPECS = ['Pool', 'Hot Tub', 'SPA', 'Kitchen', 'Restaurant', 'Breakfast Included', 'Room Service', 'Fitness Center', 'WiFi', 'A/C', 'Parking', 'Washer / Dryer', 'Pet Friendly', 'Accessible', 'Non-Smoking', 'Free Cancellation', 'Reserve Now, Pay Later', 'Airport Shuttle', 'Facilities for Disabled Guests', 'Beach Front' ];


class TravelEditFields extends Component {
    constructor(props) {
        super(props);
        this.initialState = this.state = {
            title: '',
            brandName: '',
            ticketSaleURL: '',
            category: 'select-category',
            subcategory: '',
            subcategoriesSelect: [],
            pickUp: '',
            description: '',
            price: '',
            currency: 'USD',
            callForPricing: '',
            specList: [],
            specListObj: {},
            couponList: [],
            addDiscount: 'how-about-discount',
            discountId: '',
            alreadyLoadedItem: false,
            endDate: moment().format('YYYY-MM-DD'),
            startDate: moment().format('YYYY-MM-DD'),
            // moreSpecs: [...MORE_SPECS],
            temp: {
                specName: '',
                specValue: '',
                selectWhichCoupon: '',
                discountType: '',
                discountValue: '',
                discountCurrency: '%',
                endDate: moment().format('YYYY-MM-DD'),
                startDate: moment().format('YYYY-MM-DD'),
                availability: '',
                showCouponModal: false
            }
        }
    }

    componentDidMount() {
        let Loader = new ListLoader({
            cb: this.onLoad,
            options: {
                delay: 3000,
                count: 20,
                request: {
                    url: '/api/coupons/items',
                    method: 'post',
                    formParams: { filter: JSON.stringify({ author: '', isDeal: false }) }
                }
            }
        });
        Loader.init();
        this.setState({ Loader });
        // this.onChangeItem('new-address', 'newAddress');
        setTimeout(() => {
            this.forceUpdate();
        }, 2000);
    }

    componentDidUpdate() {
        if (!this.state.alreadyLoadedItem && this.props.loadedItem.title && this.props.categoriesSelect.length) {
            let s = { ...this.state };
            let { Loader, couponList } = this.state;
            for (let i in s) {
                if (s.hasOwnProperty(i))
                    s[i] = this.props.loadedItem[i];
            }
            s.Loader = Loader;
            s.couponList = couponList;
            // if (!s.pickUp) s.pickUp = 'pick-tickets-locally';
            s.alreadyLoadedItem = true;
            s.startDate = moment(s.startDate).format('YYYY-MM-DD');
            s.endDate = moment(s.endDate).format('YYYY-MM-DD');
            // Subcategories
            let a = this.props.categoriesSelect;
            let b = [];
            let i = 0;
            for (; i < a.length; i++) {
                if (a[i] === s.category) break;
            }
            i++;
            while (/^\s*-+/.test(a[i]) && i < a.length) {
                b.push(a[i].replace(/^\s*-+\s*/, ''));
                i++;
            }
            s.subcategoriesSelect = [...b];
            // i = 0;
            // while (i < s.moreSpecs.length)
            //     if (s.specList.map(v => v.specName).indexOf(s.moreSpecs[i]) >= 0) s.moreSpecs.shift();
            //     else i++;
            s.specListObj = {};
            for (let i = 0; i < s.specList.length; i++) s.specListObj[s.specList[i].specName] = s.specList[i].specValue;
            this.setState(s);
        }
        if (this.props.loadedItem.clearAllFields !== this.state.clearAllFields) {
            this.setState({ clearAllFields: this.props.loadedItem.clearAllFields });
            let a = this.initialState;
            // a.moreSpecs = [...MORE_SPECS];
            a.specList = [];
            a.specListObj = {};
            this.setState(a);

            for (let i in a.temp) {
                this.props.onUpdateTempItem(a.temp[i], i);
            }
            for (let i in a) {
                this.props.onUpdateItem(a[i], i);
            }
        }
    }

    onLoad = () => {
        if (!this.state.Loader) return;
        let { items } = this.state.Loader;
        if (!items) items = [];
        this.setState({ couponList: items });
    }

    onChangeDiscountProperty = (e, _propName, _sizeLimit, _propMsg) => {
        let newValue = e.target.value;
        if (newValue.length > _sizeLimit) return;
        if (_propName === 'discountValue') {
            newValue = newValue.replace(/,/g, '').replace('.', '');
            newValue = Number(newValue);
            if (Number.isNaN(newValue)) newValue = 0;
            if (this.state.temp.discountCurrency === '%' && (newValue > 100 || newValue < 0)) return;
            if (this.state.temp.discountCurrency === this.state.currency && newValue > Number(this.state.price)) return;
        }
        if (_propName === 'selectWhichCoupon' && newValue === 'add-new-coupon') {
            this.setState({ temp: { ...this.state.temp, showCouponModal: true } });
        } else {
            if (!this.props.onUpdateTempState) return;
            let nextTempState = Object.assign({}, this.state.temp);
            nextTempState[_propName] = newValue;

            // Copy to all listings
            if (_propName === 'selectWhichCoupon') {
                const foundCoupon = this.state.couponList.filter(v => v.itemId === newValue)

                if (foundCoupon.length) {
                    nextTempState.discountValue = foundCoupon[0].couponValue;
                    nextTempState.discountCurrency = foundCoupon[0].couponCurrency;
                }
            }


            if (_propName === 'discountType') {
                nextTempState.discountValue = '';
                nextTempState.discountCurrency = '%';
                nextTempState.availability = '';
            }
            if (_propName === 'discountCurrency') nextTempState.discountValue = '';
            this.props.onUpdateTempState(nextTempState);
            this.setState({ temp: nextTempState });
        }
    }

    onCloseCouponModal = _newCoupon => {
        let a = this.state.couponList;
        if (!!_newCoupon) {
            a.unshift(_newCoupon);
            if (!this.props.onUpdateTempState) return;


            // Copy to all listings
            let result =
                this.props.onUpdateTempState({
                    ...this.state.temp,
                    discountValue: _newCoupon.couponValue,
                    discountCurrency: _newCoupon.couponCurrency,
                    selectWhichCoupon: _newCoupon.itemId,
                })

            if (result) {

                this.setState({
                    couponList: a,
                    temp: {
                        ...this.state.temp,
                        discountValue: _newCoupon.couponValue,
                        discountCurrency: _newCoupon.couponCurrency,
                        selectWhichCoupon: _newCoupon.itemId,
                        showCouponModal: false
                    }
                });
            }
        } else {
            this.setState({ temp: { ...this.state.temp, showCouponModal: false } });
        }
    };

    // onAddSpecSubmit = (e) => {
    //     e.preventDefault();
    //     this.onAddSpec({ newSpecName: this.state.temp.specName, newSpecValue: this.state.temp.specValue });
    //     this.state.temp.specFocusedInput.focus();
    // }

    // onAddSpec = ({ newSpecName, newSpecValue }) => {
    //     if (!newSpecValue) return;
    //     let moreSpecs = [];
    //     for (let i in this.state.moreSpecs) {
    //         if (this.state.moreSpecs[i] === this.state.temp.specName) continue;
    //         else moreSpecs.push(this.state.moreSpecs[i]);
    //     }
    //     if (this.state.moreSpecs.length === moreSpecs.length) {
    //         newSpecName = moreSpecs.shift();
    //     }
    //     if (!newSpecName) return;
    //     this.setState({ moreSpecs });

    //     let _specList = this.state.specList;
    //     _specList.push({ specName: newSpecName, specValue: newSpecValue });
    //     if (!this.props.onUpdateItem) return;
    //     let result = this.props.onUpdateItem(_specList, 'specList');
    //     if (result) this.setState({ specList: _specList, temp: { ...this.state.temp, specName: '', specValue: '' } });
    // }

    // onRemoveSpec = (k) => {
    //     let moreSpecs = this.state.moreSpecs;
    //     let _specList = this.state.specList.filter((v, i) => { if (i === k) { moreSpecs.unshift(v.specName); return false; } else return true; });
    //     if (!this.props.onUpdateItem) return;
    //     let result = this.props.onUpdateItem(_specList, 'specList');
    //     if (result) this.setState({ specList: _specList, moreSpecs });
    // }

    // onChangeSpecNameHandler = (e) => {
    //     if (e.target.value.length > 100) return;
    //     this.setState({ temp: { ...this.state.temp, specName: e.target.value } });
    // }

    // onChangeSpecValueHandler = (e) => {
    //     if (e.target.value.length > 100) return;
    //     this.setState({ temp: { ...this.state.temp, specValue: e.target.value } });
    // }

    onChangeSpecListObjItem = (value, propName, limit, message) => {
        let specList = this.state.specList;
        let specIsChanged = false;
        let moreSpecs = [];
        let specListObj = this.state.specListObj;
        specListObj[propName] = value;
        for (let i in specListObj) {
            specIsChanged = false;
            for (let j = 0; j < specList.length; j++)
                if (specList[j].specName === i) {
                    specList[j].specValue = specListObj[i];
                    specIsChanged = true;
                }
            if (!specIsChanged) moreSpecs.push({ specName: i, specValue: specListObj[i] })
        }
        specList = specList.filter(v => (v.specValue));
        moreSpecs = moreSpecs.filter(v => (v.specValue));
        this.onChangeItem([...specList, ...moreSpecs], 'specList');
        this.setState({ specListObj: { ...this.state.specListObj, [propName]: value } });
    }

    onChangeItem = (value, propName, limit, message) => {
        if (!this.props.onUpdateItem) return;
        if (propName === 'callForPricing' && value) {
            this.onChangeItem('no-discount', 'addDiscount', 50, 'Add Discount');
        }
        if (propName === 'addDiscount' && value === 'no-discount') {
            this.onChangeDiscountProperty({ target: { value: '' } }, 'discountType', 50, 'Discount Type');
        }
        if (propName === 'pickUp' && value === 'sell-online') this.props.onUpdateItem('no-address-needed', 'newAddress', 50, 'Address');
        if (propName === 'category' && value !== 'select-category') {
            let a = this.props.categoriesSelect;
            let b = [];
            let i = 0;
            for (; i < a.length; i++) {
                if (a[i] === value) break;
            }
            i++;
            while (/^\s*-+/.test(a[i]) && i < a.length) {
                b.push(a[i].replace(/^\s*-+\s*/, ''));
                i++;
            }
            this.setState({ subcategoriesSelect: [...b] })
            this.props.onUpdateItem('', 'subcategory', 50, 'Subcategory');
        }
        let result = this.props.onUpdateItem(value, propName, limit, message);
        if (result) this.setState({ [propName]: value });
    }

    onChangePriceItem = (value) => {
        value = value.replace(/,/g, '').replace('.', '');
        if (String(value).length > 12) return;
        if (!this.props.onUpdateItem) return;
        let result = this.props.onUpdateItem(value, 'price', 20, 'Price');
        if (result) this.setState({ price: value });
    }

    displayPriceValue = (value, propName) => {
        if (isNaN(value) || value === '') return '';
        if (value === '0' || value === 0) return '0';
        if (this.state.temp.discountCurrency === '%' && propName === 'discountValue') return value;
        value = String(value).split('').reverse();
        let result = [];
        for (let i = 0; i < value.length; i++) {
            if (i === 2) result.push('.');
            else if ((i > 2) && (i % 3 === 2)) result.push(',');
            result.push(value[i]);
        }
        if (result.length > 1)
            while (result[result.length - 1] === ',' || ((result[result.length - 1] === '0') && (result[result.length - 2] !== '.')))
                result.pop();
        if (value.length && value.length <= 2) result.push('.', '0');
        result = result.reverse().join('');
        return result;
    }


    render() {
        let categoriesSelect = this.props.categoriesSelect.filter(v => (!/^\s*-+/.test(v))).map(v => ({ value: v, text: getTranslatedPhrase(this.props.userLanguage, titleCase(v.replace(/-/g, ' '))) })).sort((a, b) => ((a.text > b.text) ? 1 : -1));
        return (<>



            {/* Main Info */}
            <div className="new-edit-page_section">
                <div className="new-edit-page_section-title">
                    <p>Main Info</p>
                </div>

                <div className="new-edit-page_section-content">
                    <div className="edit-page-field edit-page-field-full">
                        <input className="form-input-text form-input-full" type="text" placeholder={getTranslatedPhrase(this.props.userLanguage, 'Travel Package Name') + ' *'}
                            value={this.state.title}
                            onChange={(e) => this.onChangeItem(e.target.value, 'title', 50, 'Title')} />
                    </div>

                    <div className="edit-page-field">
                        <input className="form-input-text form-input-full" type="text" placeholder={getTranslatedPhrase(this.props.userLanguage, 'Brand Name') + ' *'}
                            value={this.state.brandName}
                            onChange={(e) => this.onChangeItem(e.target.value, 'brandName', 30, 'Brand Name')} />
                    </div>

                    <div className="edit-page-field">
                        <div className="form-input-select">
                            <select className="form-input-full" value={this.state.category} onChange={(e) => this.onChangeItem(e.target.value, 'category', 50, 'Category')}>
                                <option value="select-category">{getTranslatedPhrase(this.props.userLanguage, 'Select Category')} *</option>
                                {categoriesSelect.map((v, i) => (<option value={v.value} key={i}>{v.text}</option>))}
                            </select>
                        </div>
                    </div>

                    {!!this.state.subcategoriesSelect && !!this.state.subcategoriesSelect.length && (
                        <div className="edit-page-field">
                            <div className="form-input-select">
                                <select className="form-input-full" value={this.state.subcategory} onChange={(e) => this.onChangeItem(e.target.value, 'subcategory', 50, 'Subcategory')}>
                                    <option value="select-subcategory">{getTranslatedPhrase(this.props.userLanguage, 'Select Subcategory')}</option>
                                    {this.state.subcategoriesSelect.map((v, i) => (<option value={v} key={'sub' + i}>{getTranslatedPhrase(this.props.userLanguage, titleCase(v.replace(/-/g, ' ')))}</option>))}
                                </select>
                            </div>
                        </div>
                    )}

                    <div className="edit-page-field">
                        <div className="form-input-select">
                            <select className="form-input-full" value={this.state.pickUp} onChange={(e) => this.onChangeItem(e.target.value, 'pickUp', 50, 'Ticket picking')}>
                                <option value="pickup-location">{getTranslatedPhrase(this.props.userLanguage, 'Ticket Picking') + ' *'}</option>
                                <option value="pick-tickets-locally">{getTranslatedPhrase(this.props.userLanguage, 'Local Only')}</option>
                                <option value="sell-online">{getTranslatedPhrase(this.props.userLanguage, 'Online')}</option>
                            </select>
                        </div>
                    </div>

                    {!(this.state.pickUp === 'sell-online') ? null : (
                        <div className="edit-page-field">
                            <input type="text" className="form-input-text form-input-full" placeholder={getTranslatedPhrase(this.props.userLanguage, 'URL for buying the travel package, e.g. http://example.com') + ' *'} value={this.state.ticketSaleURL} onChange={e => this.onChangeItem(e.target.value, 'ticketSaleURL', 2000, 'URL')} />
                        </div>
                    )}

                    <div className="edit-page-field">

                    </div>
                </div>
            </div>






            {/* Pricing & Discount */}
            <div className="new-edit-page_section">
                <div className="new-edit-page_section-title">
                    <p>Pricing & Discount</p>
                </div>


                <div className="new-edit-page_section-content">
                    {!this.state.callForPricing && (<>
                        <div className="edit-page-field">
                            <input className="form-input-text form-input-full" type="text" placeholder={getTranslatedPhrase(this.props.userLanguage, 'Price') + ' *'}
                                value={this.displayPriceValue(this.state.price)}
                                onChange={(e) => this.onChangePriceItem(e.target.value)} />
                        </div>

                        <div className="edit-page-field">
                            <div className="form-input-select">
                                <select className="form-input-full" value={this.state.currency} onChange={(e) => this.onChangeItem(e.target.value, 'currency', 10, 'Currency')} >
                                    {currencyList.map(v => (
                                        <option key={v} value={v}>{v}</option>)
                                    )}
                                </select>
                            </div>
                        </div>

                        <div className="edit-page-field">
                            <div className="form-input-select">
                                <select className="form-input-full" value={this.state.addDiscount} onChange={(e) => this.onChangeItem(e.target.value, 'addDiscount', 50, 'Add Discount')}>
                                    <option value="how-about-discount">{getTranslatedPhrase(this.props.userLanguage, 'Add Discount?')} *</option>
                                    <option value="no-discount">{getTranslatedPhrase(this.props.userLanguage, 'No Discount')}</option>
                                    <option value="add-discount">{getTranslatedPhrase(this.props.userLanguage, 'Add New Discount')}</option>
                                </select>
                            </div>
                        </div>

                        {this.state.addDiscount === 'add-discount' && (
                            <div className="edit-page-field">
                                <div className="form-input-select">
                                    <select className="form-input-full" value={this.state.temp.discountType} onChange={(e) => this.onChangeDiscountProperty(e, 'discountType', 50, 'Discount Type')}>
                                        <option value="discount-type">{getTranslatedPhrase(this.props.userLanguage, 'Discount Type')} *</option>
                                        <option value="discount-coupon">{getTranslatedPhrase(this.props.userLanguage, 'Coupon')}</option>
                                        <option value="discount-deal">{getTranslatedPhrase(this.props.userLanguage, 'Deal')}</option>
                                    </select>
                                </div>
                            </div>
                        )}

                        {this.state.addDiscount === 'add-discount' && this.state.temp.discountType === 'discount-coupon' && (
                            <div className="edit-page-field">
                                <div className="form-input-select">
                                    <select className="form-input-full" value={this.state.temp.selectWhichCoupon} onChange={(e) => this.onChangeDiscountProperty(e, 'selectWhichCoupon', 50, 'Select Coupon')}>
                                        <option value="select-coupon">{getTranslatedPhrase(this.props.userLanguage, 'Select Coupon')} *</option>
                                        <option value="add-new-coupon">{getTranslatedPhrase(this.props.userLanguage, 'Add New')}</option>
                                        {this.state.couponList.map((v, i) => (
                                            <option key={'coupon-' + i} value={v.itemId}>{v.title}</option>)
                                        )}
                                    </select>
                                </div>
                            </div>
                        )}

                        {(this.state.addDiscount === 'add-discount' && this.state.temp.discountType === 'discount-deal') && (
                            <>
                                <div className="edit-page-field">
                                    <input className="form-input-text form-input-full" type="text" placeholder={getTranslatedPhrase(this.props.userLanguage, 'Discount Value *')}
                                        value={this.displayPriceValue(this.state.temp.discountValue, 'discountValue')}
                                        onChange={(e) => this.onChangeDiscountProperty(e, 'discountValue', 20, 'Discount Value')} />
                                </div>

                                <div className="edit-page-field">
                                    <div className="form-input-select">
                                        <select className="form-input-full" value={this.state.temp.discountCurrency} onChange={(e) => this.onChangeDiscountProperty(e, 'discountCurrency', 50, 'Currency')}>
                                            <option value="%">{getTranslatedPhrase(this.props.userLanguage, '%')}</option>
                                            <option value={this.state.currency}>{this.state.currency}</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="edit-page-field">
                                    <div className="form-input-select">
                                        <select className="form-input-full" value={this.state.temp.availability} onChange={(e) => this.onChangeDiscountProperty(e, 'availability', 50, 'Set Availability')}>
                                            <option value="set-availability">{getTranslatedPhrase(this.props.userLanguage, 'Set Availability')} *</option>
                                            <option value="choose-dates">{getTranslatedPhrase(this.props.userLanguage, 'Choose Dates')}</option>
                                            <option value="no-expiration-date">{getTranslatedPhrase(this.props.userLanguage, 'No Expiration Date')}</option>
                                        </select>
                                    </div>
                                </div>
                            </>
                        )}

                        {(this.state.addDiscount === 'add-discount' && this.state.temp.discountType === 'discount-deal' && this.state.temp.availability === 'choose-dates') && (
                            <>
                                <div className="edit-page-field">
                                    <input className="form-input-text form-input-full" type="date" placeholder={getTranslatedPhrase(this.props.userLanguage, 'Start Date')}
                                        value={this.state.temp.startDate}
                                        onChange={(e) => this.onChangeDiscountProperty(e, 'startDate', 20, 'Start Date')} />
                                </div>

                                <div className="edit-page-field">
                                    <input className="form-input-text form-input-full" type="date" placeholder={getTranslatedPhrase(this.props.userLanguage, 'Expiration Date')}
                                        value={this.state.temp.endDate}
                                        onChange={(e) => this.onChangeDiscountProperty(e, 'endDate', 20, 'Expiration Date')} />
                                </div>
                            </>
                        )}
                    </>)}

                    {/* <div className="edit-page-field edit-page-field-full">
                        <div className="form-input-lists">
                            <input type="checkbox" name="displayCallForPricing" checked={this.state.callForPricing} onChange={() => null} style={{ display: 'none' }} />
                            <label htmlFor="displayCallForPricing" style={{ paddingLeft: "16px", width: '100%' }}>
                                <span><i className="fal fa-check" onClick={(e) => this.onChangeItem(!this.state.callForPricing, 'callForPricing')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Call For Pricing')}
                            </label>
                        </div>
                    </div> */}
                </div>
            </div>




            {/* Dates */}
            <div className="new-edit-page_section">
                <div className="new-edit-page_section-title">
                    <p>Availability</p>
                </div>


                <div className="new-edit-page_section-content">
                    <div className="edit-page-field">
                        <label>{getTranslatedPhrase(this.props.userLanguage, 'Start Date')} *</label>
                        <input className="form-input-text form-input-full" type="date" value={this.state.startDate} onChange={e => this.onChangeItem(e.target.value, 'startDate', 50, 'Start Date')} />
                    </div>

                    <div className="edit-page-field">
                        <label>{getTranslatedPhrase(this.props.userLanguage, 'End Date')} *</label>
                        <input className="form-input-text form-input-full" type="date" value={this.state.endDate} onChange={e => this.onChangeItem(e.target.value, 'endDate', 50, 'End Date')} />
                    </div>
                </div>
            </div>



            {/* Features */}
            <div className="new-edit-page_section">
                <div className="new-edit-page_section-title">
                    <p>Specifications</p>
                </div>

                <div className="new-edit-page_section-content new-edit-page_section-content-list">
                    <div className="form-input-lists" >
                        <input type="checkbox" name="pool" checked={this.state.specListObj['Swimming Pool']} onChange={() => null} />
                        <label htmlFor="pool" >
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Swimming Pool'], 'Swimming Pool')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Swimming Pool')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="hotTub" checked={this.state.specListObj['Hot Tub']} onChange={() => null} />
                        <label htmlFor="hotTub">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Hot Tub'], 'Hot Tub')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Hot Tub')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="spa" checked={this.state.specListObj.SPA} onChange={() => null} />
                        <label htmlFor="spa" >
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj.SPA, 'SPA')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'SPA')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="breakfastIncluded" checked={this.state.specListObj['Breakfast Included']} onChange={() => null} />
                        <label htmlFor="breakfastIncluded" >
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Breakfast Included'], 'Breakfast Included')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Breakfast Included')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="kitchen" checked={this.state.specListObj.Kitchen} onChange={() => null} />
                        <label htmlFor="kitchen">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj.Kitchen, 'Kitchen')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Kitchen')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="restaurant" checked={this.state.specListObj.Restaurant} onChange={() => null} />
                        <label htmlFor="restaurant">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj.Restaurant, 'Restaurant')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Restaurant')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="roomService" checked={this.state.specListObj['Room Service']} onChange={() => null} />
                        <label htmlFor="roomService" >
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Room Service'], 'Room Service')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Room Service')}
                        </label>
                    </div>

                    <div className="form-input-lists">
                        <input type="checkbox" name="fitnessCenter" checked={this.state.specListObj['Fitness Center']} onChange={() => null} />
                        <label htmlFor="fitnessCenter">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Fitness Center'], 'Fitness Center')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Fitness Center')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="freeWifi" checked={this.state.specListObj['Free Wifi']} onChange={() => null} />
                        <label htmlFor="freeWifi">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Free Wifi'], 'Free Wifi')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Free Wifi')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="freeParking" checked={this.state.specListObj['Free Parking']} onChange={() => null} />
                        <label htmlFor="freeParking">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Free Parking'], 'Free Parking')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Free Parking')}
                        </label>
                    </div>

                    <div className="form-input-lists">
                        <input type="checkbox" name="ac" checked={this.state.specListObj['A/C']} onChange={() => null} />
                        <label htmlFor="ac">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['A/C'], 'A/C')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'A/C')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="washerDryer" checked={this.state.specListObj['Washer / Dryer']} onChange={() => null} />
                        <label htmlFor="washerDryer">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Washer / Dryer'], 'Washer / Dryer')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Washer / Dryer')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="petFriendly" checked={this.state.specListObj['Pet Friendly']} onChange={() => null} />
                        <label htmlFor="petFriendly">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Pet Friendly'], 'Pet Friendly')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Pet Friendly')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="nonSmokingRoom" checked={this.state.specListObj['Non-Smoking Rooms']} onChange={() => null} />
                        <label htmlFor="nonSmokingRoom">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Non-Smoking Rooms'], 'Non-Smoking Rooms')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Non-Smoking Rooms')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="accessible" checked={this.state.specListObj.Accessible} onChange={() => null} />
                        <label htmlFor="accessible">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj.Accessible, 'Accessible')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Accessible')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="facilitiesForDisabledGuests" checked={this.state.specListObj['Facilities For Disabled Guests']} onChange={() => null} />
                        <label htmlFor="facilitiesForDisabledGuests" >
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Facilities For Disabled Guests'], 'Facilities For Disabled Guests')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Facilities For Disabled Guests')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="freeCancelation" checked={this.state.specListObj['Free Cancelation']} onChange={() => null} />
                        <label htmlFor="freeCancelation">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Free Cancelation'], 'Free Cancelation')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Free Cancelation')}
                        </label>
                    </div>

                    <div className="form-input-lists">
                        <input type="checkbox" name="reserveNowPayLater" checked={this.state.specListObj['Reserve Now Pay Later']} onChange={() => null} />
                        <label htmlFor="reserveNowPayLater">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Reserve Now Pay Later'], 'Reserve Now Pay Later')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Reserve Now Pay Later')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="beachFront" checked={this.state.specListObj['Beach Front']} onChange={() => null} />
                        <label htmlFor="beachFront">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Beach Front'], 'Beach Front')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Beach Front')}
                        </label>
                    </div>
                    <div className="form-input-lists">
                        <input type="checkbox" name="airportShuttle" checked={this.state.specListObj['Airport Shuttle']} onChange={() => null} />
                        <label htmlFor="airportShuttle">
                            <span><i className="fal fa-check" onClick={(e) => this.onChangeSpecListObjItem(!this.state.specListObj['Airport Shuttle'], 'Airport Shuttle')} /></span>{getTranslatedPhrase(this.props.userLanguage, 'Airport Shuttle')}
                        </label>
                    </div>
                </div>
            </div>



            {/* Description */}
            <div className="new-edit-page_section">
                <div className="new-edit-page_section-title">
                    <p>Description</p>
                </div>


                <div className="new-edit-page_section-content">
                    <div className="edit-page-field edit-page-field-full">
                        <textarea
                            className="form-input-textarea form-input-full"
                            placeholder={getTranslatedPhrase(this.props.userLanguage, 'Write your travel package description. *')}
                            value={this.state.description}
                            onChange={(e) => this.onChangeItem(e.target.value, 'description', 10000, 'Description')} >
                        </textarea>
                    </div>
                </div>
            </div>


            <CreateCouponModal
                active={this.state.temp.showCouponModal}
                onClose={this.onCloseCouponModal}
                initialPrice={this.state.price}
                oldCoupon={null}
                couponCurrency={this.state.currency}
            />
        </>);
    }
}

export default TravelEditFields;
